export default "__VITE_ASSET__B7o7PG8K__"